import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment><path d="M7 10l5 5 5-5z" /><path fill="none" d="M0 0h24v24H0z" /></React.Fragment>
, 'ArrowDropDown');
